<script>
    import { onMount } from 'svelte';
    import Modal from "../components/Modal.svelte";	
    import Modal_series from "../components/Modal_series.svelte";	
    import Modal_alta from "../components/Modal_alta.svelte";	
	import { jwt } from "../store/index.js";
    import Top from "../components/top.svelte";	
    import { iddistribuidor, nombre } from '../store/distribuidor.js';
    let idtarjeta_predeterminada;
    let pago_modal1;
    let idddib = $jwt;
    console.log(idddib);
    let datos=[];
    let data=[];
    let modal_alta;
    let web;
    let telefonos;
    let correoContacto;
    let correoSesion;
    let domicilio;
    let cp;
    let latitud;
    let longitud;
    let password;
    let password_confirm;
    let nombre_tecnico;
    let correo_tecnico;
    let telefono_tecnico;
    let password_tecnico;
    let skype_tecnico;
    let nombre_tecnico_edit;
    let correo_tecnico_edit;
    let telefono_tecnico_edit;
    let password_tecnico_edit;
    let skype_tecnico_edit;
	let car;
    let tecnic;
    let pago_modal;
    let modal_modificar;
    let idtecnico;
    let series_tecnico;
    let alta_serie_tecnico;
    let serie;
    let sistem = "Windows";
    let host;
    let user;
    let passw;
    let port;
    let permiso;
    let idtecnico_alta;
    let referencia;
    let idlicencia;
    let actives = "pestaña1";
    let actives1 = "pestaña";
    let show_a = true;
    let show_a1 = false;
    let show = true;
    let show1 = false;
    let show2 =false;
    let activer = "pestaña1";
    let activer1 = "pestaña";
    let activer2 = "pestaña";
    let tarjeta_number;
    let MM;
    let AA;
    let cvc;
    let idsuscripcion = "";
    let cantidad;
    let idstripe;
    let tarjetas = [];
    let yes=false;
    let tecnicos_licencia;
    let tecnicos_sobrantes;
    let cargos_extra=[];
    let modal_tecnicos;
    let modal_agregar_tarjeta;
    let predeterminada;
    let precio_suscripcion;
    let fecha_proxima;
    let button_pago =false;
    let tec_extras ;
    let tecnicos_totales;

    async function agregar_tarjeta_nueva(){
            const data1 = new FormData()
            data1.append('month', MM);
            data1.append('year', AA);
            data1.append('cvc', cvc);
            data1.append('idstripe', datos.idstripe);
            let resa = await fetch('php/alta-tarjeta.php', {
                method : "POST",
                body: data1
            })		
			resa = await resa.json()
			console.log(resa);
            if(resa){
            const data2 = new FormData()
            data2.append('idstripe', datos.idstripe);
            data2.append('idtarjeta', resa);
            let resa1 = await fetch('php/guardar-tarjeta-nueva.php', {
                method : "POST",
                body: data2
            })	
            }
            const url3 = 'php/get-tarjetas.php?idstripe=' + idstripe;
            let res3 = await fetch(url3)
            res3 = await res3.json()
            console.log(res3)
            tarjetas = res3.data;
            predeterminada = idtarjeta_predeterminada;
            modal_agregar_tarjeta.hide();
    }
    async function eliminar_tarjeta(i){
        if(tarjetas[i].id == idtarjeta_predeterminada){
            alert("No puede eliminar la tarjeta predeterminada");
        }else{
        let r2 = window.confirm("¿Desea eliminar la tarjeta **** **** **** " + tarjetas[i].last4 + "?");
            if (r2 == true) {
                const data1 = new FormData()
                data1.append('idtarjeta', tarjetas[i].id);
                data1.append('idstripe', datos.idstripe);
                let resa = await fetch('php/baja-tarjeta.php', {
                    method : "POST",
                    body: data1
                })		
                const url3 = 'php/get-tarjetas.php?idstripe=' + datos.idstripe;
                let res3 = await fetch(url3)
                res3 = await res3.json()
                console.log(res3)
                tarjetas = res3.data;
                predeterminada = idtarjeta_predeterminada;
            }
        }
      
    }
    async function modificar_preferente(){
        let r2 = window.confirm("Confirme el cambio de tarjeta predeterminada");
            if (r2 == true) {
                const data1 = new FormData()
                data1.append('idtarjeta', predeterminada);
                data1.append('idstripe', datos.idstripe);
                data1.append('idtarjeta_predeterminada', idtarjeta_predeterminada);
                let resa = await fetch('php/cambiar-predeterminado.php', {
                    method : "POST",
                    body: data1
                })		
                const url3 = 'php/get-tarjetas.php?idstripe=' + datos.idstripe;
                let res3 = await fetch(url3)
                res3 = await res3.json()
                console.log(res3)
                tarjetas = res3.data;
                const url4 = 'php/tarjeta-predeterminada.php?idstripe=' + idstripe;
                let res4 = await fetch(url4)
                res4 = await res4.json()
                console.log(res4)
                idtarjeta_predeterminada = res4.data.idtarjeta;
                predeterminada = idtarjeta_predeterminada;
            }
    }
    async function agregar_tarjeta(){
        modal_agregar_tarjeta.show();
    }
    async function eliminar_tecnico_licencia(i){
        idlicencia = data[i].idlicencia;
        idtecnico = data[i].idsoporte;
        let r2 = window.confirm("¿Desea eliminar el tecnico " + data[i].nombre + "?");
        if (r2 == true) {
            try {
            const data2 = new FormData()
            data2.append('id', idtecnico);
            let res = await fetch('php/delete-tecnico.php', {
                method : "POST",
                body: data2
            })
            console.log(res)
            const data1 = new FormData()
            data1.append('id', idlicencia);
            let resa = await fetch('php/delete-series.php', {
                method : "POST",
                body: data1
            })
            tecnicos_licencia =  parseInt(tecnic) - 1;
                const data = new FormData()
                data.append('id', datos.iddistribuidor);
                data.append('tecnicos', tecnicos_licencia);
                let res12 = await fetch('php/delete-licencia.php', {
                    method : "POST",
                    body: data
                })		
            alert("Licencia eliminada con exito");
            actualizar();
            modal_tecnicos.hide();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
        }
    }
    async function eliminar_licencia(){
        if(car >= tecnic){
            modal_tecnicos.show();
        } else {
            let r2 = window.confirm("Eliminara una licencia extra, confirme la accion. Atencion: no hay reembolso al eliminar la licencia");
            if (r2 == true) {
                try {
                tecnicos_licencia =  parseInt(tecnic) - 1;
                const data = new FormData()
                data.append('id', datos.iddistribuidor);
                data.append('tecnicos', tecnicos_licencia);
                let res = await fetch('php/delete-licencia.php', {
                    method : "POST",
                    body: data
                })		
                alert("Eliminado con exito");
                actualizar();
                } catch(e) {
                    const { responses } = e;
                    const { request, ...errorObject } = responses; // take everything but 'request'
                    console.log(errorObject);
                    }
            }
        }
        
    }
    async function guardar_tarjeta(){
            const data1 = new FormData()
            data1.append('month', MM);
            data1.append('year', AA);
            data1.append('cvc', cvc);
            data1.append('idstripe', datos.idstripe);
            let resa = await fetch('php/alta-tarjeta.php', {
                method : "POST",
                body: data1
            })		
			resa = await resa.json()
			console.log(resa);
            if(resa){
            const data2 = new FormData()
            data2.append('idstripe', datos.idstripe);
            data2.append('idtarjeta', resa);
            let resa1 = await fetch('php/guardar-tarjetas.php', {
                method : "POST",
                body: data2
            })	
            pago_modal1.hide();
            if(cantidad == "4000.000"){
                const data3 = new FormData()
                data3.append('idstripe', datos.idstripe);
                let resa2 = await fetch('php/suscripcion2.php', {
                method : "POST",
                body: data3
                })	
            }else if(cantidad == "8000.000"){
                const data3 = new FormData()
                data3.append('idstripe', datos.idstripe);
                let resa2 = await fetch('php/suscripcion.php', {
                method : "POST",
                body: data3
                })	
            } else {
                alert("No se pudo realizar el pago, contacte con Kitaoka")
            }
        }
    }
    function showa(){
		show_a = true;
		show_a1 = false;
        actives="pestaña1";
        actives1="pestaña";
	}
    function showa1(){
		show_a = false;
		show_a1 = true;
        actives="pestaña";
        actives1="pestaña1";
	}
    function showan(){
		show = true;
		show1 = false;
		show2 = false;
        activer="pestaña1";
        activer1="pestaña";
        activer2="pestaña";
	}
    function showan1(){
		show = false;
		show1 = true;
		show2 = false;
        activer="pestaña";
        activer1="pestaña1";
        activer2="pestaña";
	}
    function showan2(){
		show = false;
		show1 = false;
		show2 = true;
        activer="pestaña";
        activer1="pestaña";
        activer2="pestaña1";
	}
    async function licencia_tecnico(){
        tec_extras = parseInt(tecnicos_sobrantes)+1;
        if(tec_extras == 1){
            let r2 = window.confirm("Confirme la adquicision de una licencia de tecnico extra por un costo de $ 1000.00, mas una cantidad extra por el remanente por los dias a restantes");
            if (r2 == true) {
                try {
                tecnicos_licencia =  parseInt(tecnic) + 1;
                const data = new FormData()
                data.append('idtarjeta', idtarjeta_predeterminada);
                data.append('idstripe', datos.idstripe);
                data.append('tecnicos', tecnicos_licencia);
                data.append('idsuscripcion', idsuscripcion);
                let res = await fetch('php/licencia-extra.php', {
                    method : "POST",
                    body: data
                })		
                alert("Cobro realizado con exito");
                actualizar();
                } catch(e) {
                    const { responses } = e;
                    const { request, ...errorObject } = responses; // take everything but 'request'
                    console.log(errorObject);
                    }
            }
        } else {
            let r2 = window.confirm("Confirme la adquicision de una licencia de tecnico extra por un costo de $ 1000.00, mas una cantidad extra por el remanente por los dias a restantes.");
            if (r2 == true) {
                try {
                tecnicos_licencia =  parseInt(tecnic) + 1;
                const data = new FormData()
                data.append('idtarjeta', idtarjeta_predeterminada);
                data.append('idstripe', datos.idstripe);
                data.append('tecnicos', tecnicos_licencia);
                data.append('tecnicos_extra', tec_extras);
                data.append('idsuscripcion', idsuscripcion);
                let res = await fetch('php/add-item.php', {
                    method : "POST",
                    body: data
                })		
                alert("Cobro realizado con exito");
                actualizar();
                } catch(e) {
                    const { responses } = e;
                    const { request, ...errorObject } = responses; // take everything but 'request'
                    console.log(errorObject);
                    }
            }
        }
        
    }
    async function series(i){
        idtecnico_alta = data[i].idsoporte;
        if(data[i].Serie){
            serie = data[i].Serie;
            host = data[i].Host_local;
            sistem = data[i].Sistema_Operativo;
            port = data[i].Port;
            user = data[i].User;
            passw = data[i].Pass;
            referencia = data[i].nombre;
            permiso = 1;
        } else {
            referencia = data[i].nombre;
            serie = "";
            sistem = "Windows";
            host = "127.0.0.1";
            port="3319";
            user = "root";
            passw = "root";
            permiso=0;
        }
        alta_serie_tecnico.show();
    }
    async function alta_serie(){
        alert(sistem);
        alert(host);
        try {
            const data = new FormData()
            data.append('serie', serie);
            data.append('sistema_operativo', sistem);
            data.append('port', port);
            data.append('user', user);
            data.append('pass', passw);
            data.append('host', host);
            data.append('referencia', referencia);
            data.append('id', idtecnico_alta);
            if(sistem == "Android"){
                data.append('tipo', "1");
            } else if(sistem == "IOS"){
                data.append('tipo', "1");
            } else{
                data.append('tipo', "0");
            }
            let res = await fetch('php/alta-series-tecnico.php', {
                method : "POST",
                body: data
            })		
            alert("Serie guardada con exito");
            alta_serie_tecnico.hide();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
        actualizar();
    }
    
    async function modificar_serie_tecnico(){
        try {
            const data = new FormData()
            data.append('serie', serie);
            data.append('sistema_operativo', sistem);
            data.append('port', port);
            data.append('user', user);
            data.append('pass', passw);
            data.append('host', host);
            data.append('id', idtecnico_alta);
            let res = await fetch('php/update-series-tecnico.php', {
                method : "POST",
                body: data
            })
            alert("Modificado con exito");
            actualizar();
            alta_serie_tecnico.hide();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
    }
    function initMap() {		
        var map = new google.maps.Map(document.getElementById('mapa'), {
          zoom: 6,
          center: {lat: _lat, lng: _lon}
        });
			    
        var marker1 = new google.maps.Marker({
          position: {lat: _lat, lng: _lon},
          map: map,
		  title: "",
        });		
      }

      async function editar(i){
        nombre_tecnico_edit = data[i].nombre;
        correo_tecnico_edit = data[i].correo;
        telefono_tecnico_edit = data[i].celular;
        password_tecnico_edit = data[i].password;
        skype_tecnico_edit = data[i].skype;
        idtecnico = data[i].idsoporte;
        modal_modificar.show();
      }

      async function guardar_edicion(){
        try {
            const data = new FormData()
            data.append('nombre', nombre_tecnico_edit);
            data.append('password', password_tecnico_edit);
            data.append('telefono', telefono_tecnico_edit);
            data.append('skype', skype_tecnico_edit);
            data.append('correo',correo_tecnico_edit);
            data.append('id', idtecnico);
            let res = await fetch('php/update_tecnico.php', {
                method : "POST",
                body: data
            })
            console.log(res)
            alert("Cambios guardados");
            actualizar();
            modal_modificar.hide();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
      }
      async function eliminar(i){
        idlicencia = data[i].idlicencia;
        idtecnico = data[i].idsoporte;
        let r2 = window.confirm("¿Desea eliminar el tecnico " + data[i].nombre + "?");
        if (r2 == true) {
            try {
            const data2 = new FormData()
            data2.append('id', idtecnico);
            let res = await fetch('php/delete-tecnico.php', {
                method : "POST",
                body: data2
            })
            console.log(res)
            const data1 = new FormData()
            data1.append('id', idlicencia);
            let resa = await fetch('php/delete-series.php', {
                method : "POST",
                body: data1
            })
            actualizar();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
        }
      }

      async function crear_tecnico(){
        try {
            const data = new FormData()
            data.append('nombre', nombre_tecnico);
            data.append('password', password_tecnico);
            data.append('celular', telefono_tecnico);
            data.append('skype', skype_tecnico);
            data.append('correo', correo_tecnico);
            data.append('id', idddib);
            let res = await fetch('php/create-user.php', {
                method : "POST",
                body: data
            })
            console.log(res)
		alert("creado con exito");
        nombre_tecnico = "";
        password_tecnico = "";
        telefono_tecnico = "";
        skype_tecnico = "";
        correo_tecnico = "";
        actualizar();
        modal.hide();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
      }

      async function actualizar(){
        const url = 'php/get-user.php?id=' + idddib;
        let res = await fetch(url)
        res = await res.json()
        console.log(res)
        datos = res.data;
        tecnicos_totales = parseInt(datos.tecnicos_gratis) + parseInt(datos.tecnicos_adicionales);
        web = datos.url;
        telefonos= datos.telefonos;
        tecnic = datos.tecnicos;
        correoContacto=datos.correo;
        correoSesion=datos.correo_sesion;
        domicilio=datos.domicilio;
        latitud=datos.latitud;
        longitud=datos.longitud;
       
        cantidad = datos.cuota;
        idstripe = datos.idstripe;
        cp=datos.cp;
       
        const url1 = 'php/get-tecnicos.php?id=' + idddib;
        let res1 = await fetch(url1)
        res1 = await res1.json()
        data = res1.data;
        if(data){
            car=data.length;
        } else {
            car=0;  
        } 
        console.log(data)
        const url3 = 'php/get-tarjetas.php?idstripe=' + idstripe;
        let res3 = await fetch(url3)
        res3 = await res3.json()
        console.log(res3)
        tarjetas = res3.data;
        const url4 = 'php/tarjeta-predeterminada.php?idstripe=' + idstripe;
        let res4 = await fetch(url4)
        res4 = await res4.json()
        console.log(res4)
        if(res4){
            idtarjeta_predeterminada = res4.data.idtarjeta;
            predeterminada = idtarjeta_predeterminada;
        }
      }
      
    onMount(async () => {
        const url = 'php/get-user.php?id=' + idddib;
        let res = await fetch(url)
        res = await res.json()
        console.log(res)
        datos = res.data;
        tecnicos_totales = datos.tecnicos_gratis + datos.tecnicos_adicionales;
        web = datos.url;
        telefonos= datos.telefonos;
        tecnic = datos.tecnicos;
        correoContacto=datos.correo;
        correoSesion=datos.correo_sesion;
        domicilio=datos.domicilio;
        latitud=datos.latitud;
        longitud=datos.longitud;
       
        cantidad = datos.cuota;
        idstripe = datos.idstripe;
        cp=datos.cp;
       
        const url1 = 'php/get-tecnicos.php?id=' + idddib;
        let res1 = await fetch(url1)
        res1 = await res1.json()
        data = res1.data;
        if(data){
            car=data.length;
        } else {
            car=0;  
        } 
        console.log(data)
        const url3 = 'php/get-tarjetas.php?idstripe=' + idstripe;
        let res3 = await fetch(url3)
        res3 = await res3.json()
        console.log(res3)
        tarjetas = res3.data;
    })
    async function modal_alta_tecnico(){
        if(car >= tecnic){
            alert("Ha excedido el limite de tecnicos permitidos. Favor de solicitar mas");
        } else {
            modal.show();
        }
    }
    async function info(){
        try {
            const data = new FormData()
            data.append('correo_contacto', correoContacto);
            data.append('correo_sesion', correoSesion);
            data.append('telefono', telefonos);
            data.append('sitio', web);
            data.append('id', idddib);
            let res = await fetch('php/update_datos.php', {
                method : "POST",
                body: data
            })
            console.log(res)
		alert("creado con exito");
        actualizar();
        modal_alta.hide();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
    }
    async function ubica(){
        try {
            const data = new FormData()
            data.append('cp', cp);
            data.append('domicilio', domicilio);
            data.append('latitud', latitud);
            data.append('longitud', longitud);
            data.append('id', idddib);
            let res = await fetch('php/update_localization.php', {
                method : "POST",
                body: data
            })
            console.log(res)
		alert("creado con exito");
        actualizar();
        modal_alta.hide();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
    }
    async function pass(){
        try {
            const data = new FormData()
            data.append('password', password);
            data.append('id', idddib);
            let res = await fetch('php/update_contraseña.php', {
                method : "POST",
                body: data
            })
            console.log(res)
		alert("creado con exito");
        actualizar();
        modal_alta.hide();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
    }
    let modal;
</script>
<Top/>
<seciton>
    <div class="informacion_general">
        <div class="contenedor">
            <div class="row1">
                <div class="etiqueta">
                    <h3>Profile</h3>
                </div>
                <div class="icon"  on:click={() => modal_alta.show()}>
                    <img src="./img/editar.svg" alt="">
                </div>
            </div>
            <div class="row1">
                <div class="parte1">
                    <div class="info">
                        <img class="logo_imagen" src="https://kitaokatech.com/web_desktop/galeria/logos_distribuidor/{datos.file_logo}" alt="">
                        <h4><b>Registration Date:</b> {datos.alta}</h4>
                        <h4><b>Web site:</b> {datos.url}</h4>
                        <h4><b>Phone:</b> {datos.telefonos}</h4>
                        <h4><b>Contact email:</b> {datos.correo}</h4>
                        <h4><b>Session email:</b> {datos.correo_sesion}</h4>
                        <h4><b>Address:</b> {datos.domicilio}</h4>
                        <h4><b>Location:</b> {datos.cuidad}, {datos.provincia}</h4>
                        <h4><b>Credentials:</b> User: {datos.usurio_db} Password: {datos.pass_db}</h4>

                            <h4><b>Monthly payment:</b> ${datos.cuota_neto}</h4>
                            <h4><b>Licensing:</b> {tecnicos_totales}</h4>
                            <h4 class="fecha"><b>Cutoff date:</b> {datos.vigencia}</h4>
                            <button on:click={() => pago_modal.show()}><img src="./img/ver.svg" alt=""></button>
                       
                    </div>
                </div>
                <div class="parte2">
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117308.79773474668!2d-106.49231753223347!3d23.246728325066588!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x869f5341681837c1%3A0x62a4c4aaf13c72b2!2zTWF6YXRsw6FuLCBTaW4u!5e0!3m2!1ses-419!2smx!4v1615149353434!5m2!1ses-419!2smx" width="80%" height="300" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                </div>
            </div>
        </div>
    </div>
</seciton>
<section>
    <div class="tecnicos">
        <div class="contenedor">
            <div class="row1">
                <div class="etiqueta">
                    <h3>Technician List</h3>
                </div>
                <div class="icon" on:click={() => modal_alta_tecnico()}>
                    <img src="./img/mas.svg" alt="">
                </div>
            </div>
            <div class="tabla_tecnicos">
                <table>
                    <thead>
                        <th class="column">Technical</th>
                        <th class="column1">Alta</th>
                        <th class="column2">Email</th>
                        <th class="column3">Cell phone</th>
                        <th class="column4">Skype</th>
                        <th class="column5"></th>
                        <th class="column5"></th>
                        <th class="column6"></th>
                    </thead>
                    <tbody>
                        {#if data}
                            {#each data as row, i}
                            <tr>
                                <td class="column">{row.nombre}</td>
                                <td class="column1">{row.alta}</td>
                                <td class="column2">{row.correo}</td>
                                <td class="column3">{row.celular}</td>
                                <td class="column4">{row.skype}</td>
                                <td class="column5" on:click={() => editar(i)}><img src="./img/editar.svg" alt=""></td>
                                <td class="column6" on:click={() => eliminar(i)}><img src="./img/menos.svg" alt=""></td>
                                <td class="column6" on:click={() => series(i)}><img src="./img/llave.svg" alt=""></td>
                            </tr>
                            {/each}
                        {/if}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="tecnicos_movil">
        <div class="contenedor">
            <div class="row1">
                <div class="etiqueta">
                    <h3>Technician List</h3>
                </div>
                <div class="icon" on:click={() => modal_alta_tecnico()}>
                    <img src="./img/mas.svg" alt="">
                </div>
            </div>
        </div>
        <div class="tabla_tecnicos_movil">
            {#if data}
                {#each data as datos, i}
                <div class="renglon">
                    <h4><b>Name: </b>{datos.nombre}</h4>
                    <h4><b>Register: </b>{datos.alta}</h4>
                    <h4><b>Email: </b>{datos.correo}</h4>
                    <h4><b>Cell phone: </b>{datos.celular}</h4>
                    <h4><b>Skype: </b>{datos.skype}</h4>
                    <h3 on:click={() => editar(i)}><img src="./img/editar.svg" alt=""></h3>
                    <h3 on:click={() => eliminar(i)}><img src="./img/menos.svg" alt=""></h3>
                    <h3 on:click={() => series(i)}><img src="./img/llave.svg" alt=""></h3>
                </div>
                {/each}
            {/if}
        </div>
    </div>
</section>
    <Modal_alta bind:this={modal_alta}>
        <div class="cabecera_modal">
            <div class="row1">
                <div class="{activer}" on:click={showan}>
                    <h4>General data</h4>
                </div>
                <div class="{activer1}" on:click={showan1}>
                    <h4>Localization</h4>
                </div>
                <div class="{activer2}" on:click={showan2}>
                    <h4>Password</h4>
                </div>
            </div>
        </div>
        {#if show}
        <div class="modal1">
            <form on:submit|preventDefault={info}>
                    <h2 class="titulo-modal">Contact details</h2>
                    <h4>Web site</h4>
                    <input class="modal_input" type="text" bind:value={web} required>
                    <h4>Phone</h4>
                    <input class="modal_input" type="text" bind:value={telefonos} required>
                    <h4>Contact email</h4>
                    <input class="modal_input" type="email" bind:value={correoContacto} required>
                    <h4>Session email</h4>
                    <input class="modal_input" type="email" bind:value={correoSesion} required>
                    <button type="submit" class="modal_button">Modify profile</button>
            </form>
        </div>
        {/if}
        {#if show1}
        <div class="modal1">
            <form on:submit|preventDefault={ubica}>
                <h2 class="titulo-modal">Location</h2>
                <h4>Address</h4>
                <input class="modal_input" type="text" bind:value={domicilio} required>
                <h4>Postal code</h4>
                <input class="modal_input" type="text" bind:value={cp} required>
                <h4>Latitude</h4>
                <input class="modal_input" type="text" bind:value={latitud} required>
                <h4>Longitude</h4>
                <input class="modal_input" type="text" bind:value={longitud} required>
                <button type="submit" class="modal_button">Modificar Datos de Ubicación</button>
            </form>
        </div>
        {/if}
        {#if show2}
        <div class="modal1">
            <form on:submit|preventDefault={pass}>
                <h2 class="titulo-modal">Password</h2>
                <h4>New Password</h4>
                <input class="modal_input" type="password" bind:value={password} required>
                <h4>Confirm Password</h4>
                <input class="modal_input" type="password" bind:value={password_confirm} required>
                <button type="submit" class="modal_button">Modify password</button>
            </form>
        </div>
        {/if}
    </Modal_alta>

<Modal_alta bind:this={modal}>
    <form on:submit|preventDefault={crear_tecnico}>
        <h2 class="titulo-modal">New Technician</h2>
        <h4 class="texto_modal">Name <b style="color:red">*</b> </h4>
        <input type="text" class="input_modal" bind:value={nombre_tecnico} required>
        <h4 class="texto_modal">Email <b style="color:red">*</b></h4>
        <input type="email" class="input_modal"  bind:value={correo_tecnico} required>
        <h4 class="texto_modal">Password <b style="color:red">*</b></h4>
        <input type="text" class="input_modal"  bind:value={password_tecnico} required>
        <h4 class="texto_modal">Cell phone</h4>
        <input type="text" class="input_modal"  bind:value={telefono_tecnico}>
        <h4 class="texto_modal">Skype <b style="color:red">*</b></h4>
        <input type="text" class="input_modal"  bind:value={skype_tecnico} required>
        <button class="modal_button" type="submit">Create</button>
    </form>
</Modal_alta>
<Modal_alta bind:this={pago_modal}>
    <div class="cabecera_modal">
        <div class="row1">
            <div class="{actives}" on:click={showa}>
                <h4>Information</h4>
            </div>
            <div class="{actives1}" on:click={showa1}>
                <h4>Payment method</h4>
            </div>
        </div>
    </div>
    {#if show_a}
        <div class="row1"> 
            <div class="parte3_modal">
                <h2>Monthly payment</h2>
            </div>
            <div class="parte4_modal">
                <h2>${cantidad}</h2>
            </div>
        </div>
        <hr>          
        <div class="row1"> 
            <div class="parte3_modal">
                <h4><b>Extras</b></h4>          
            </div>
            <div class="parte4_modal">
                <div class="mas" on:click={() => licencia_tecnico()}><img src="./img/mas.svg" alt=""></div>
            </div>
        </div>
        <hr>
        {#each cargos_extra as cargos_extra, i}
            <div class="row1"> 
                <div class="parte5_modal">
                    <h4>{cargos_extra.Concepto}</h4>            
                </div>
                <div class="parte6_modal">
                    <h4>$ {cargos_extra.Pago}</h4>
                </div>
            </div>
        {/each}
        {#if cargos_extra}
            <hr>
        {/if}
        {#if precio_suscripcion}
            <div class="row1"> 
                <div class="parte3_modal">
                    <h4>Total</h4>
                    <h4><b>Next payment</b></h4>              
                </div>
                <div class="parte4_modal">
                    <h4>$ {precio_suscripcion}</h4>
                    <h4>{fecha_proxima}</h4>
                </div>
            </div>
        {/if}
    {/if}
    {#if show_a1}
        <div class="container_tarjeta"> 
            <div class="row1">
                <div class="modal_frac1_cabecera">
                    <h4>Card number</h4>
                </div>
                <div class="modal_frac2_cabecera">
                    <h4>Type</h4>
                </div>
                <div class="modal_frac3_cabecera">
                    <img on:click={() => agregar_tarjeta()} src="./img/mas.svg" alt="">
                </div>
            </div>
            <hr>
            <form on:submit|preventDefault={modificar_preferente}>
            {#each tarjetas as Tarjetas, i}
            <div class="row1">
                <div class="modal_frac1">
                        <input bind:group={predeterminada} type="radio" name="amount" value={Tarjetas.id} />
                </div>
                <div class="modal_frac2">
                    <h4>**** **** **** {Tarjetas.last4}</h4>
                </div>
                <div class="modal_frac3">
                    {#if Tarjetas.brand == "Visa"}
                        <img src="./img/visa.svg" alt="">
                    {:else}
                        <img src="./img/mastercard.svg" alt="">
                    {/if}
                </div>
                <div class="modal_frac4">
                    <img on:click={() => eliminar_tarjeta(i)} src="./img/menos.svg" alt="">
                </div>
            </div>
            {/each}
            <button class="modal_button"  type="submit">Save changes</button>
            </form>
        </div>
    {/if}
</Modal_alta>
<Modal_alta bind:this={modal_modificar}>
    <form on:submit|preventDefault={guardar_edicion}>
        <h2 class="titulo-modal">Technician information</h2>
        <h4 class="texto_modal">Name</h4>
        <input type="text" class="input_modal" bind:value={nombre_tecnico_edit} required>
        <h4 class="texto_modal">Email</h4>
        <input type="text" class="input_modal"  bind:value={correo_tecnico_edit} required>
        <h4 class="texto_modal">Password</h4>
        <input type="text" class="input_modal"  bind:value={password_tecnico_edit} required>
        <h4 class="texto_modal">Cell phone</h4>
        <input type="text" class="input_modal"  bind:value={telefono_tecnico_edit}>
        <h4 class="texto_modal">Skype</h4>
        <input type="text" class="input_modal"  bind:value={skype_tecnico_edit} required>
        <button class="modal_button" type="submit">Save changes</button>
    </form>
</Modal_alta>
<Modal_alta bind:this={alta_serie_tecnico}>
        <h2 class="titulo-modal">Technician Serie</h2>
        <h4 class="texto_modal">Serial number</h4>
        <input type="text" class="input_modal" bind:value={serie} required placeholder="número alfanumerico">
        <h4 class="texto_modal">Operating system or platform</h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem} value={"Windows"}> Windows
        </h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem} value={"linux"}> Linux
        </h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem} value={"Mac OS"}> Mac OS
        </h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem} value={"Android"}> Android
        </h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem} value={"IOS"}> IOS
        </h4>
        <h4 class="texto_modal">connection host:</h4>
        <input type="text" class="input_modal"  bind:value={host} required>
        <h4 class="texto_modal">Port:</h4>
        <input type="text" class="input_modal"  bind:value={port} required>
        <h4 class="texto_modal">User:</h4>
        <input type="text" class="input_modal"  bind:value={user} required>
        <h4 class="texto_modal">Password:</h4>
        <input type="text" class="input_modal"  bind:value={passw} required>
        {#if permiso == 0}
            <button class="modal_button" on:click={() => alta_serie()}>Save changes</button>
        {:else}
            <button class="modal_button" on:click={() => modificar_serie_tecnico()}>Modify</button>
        {/if}
        <button class="modal_button"  on:click={() => alta_serie_tecnico.hide()}>Close</button>
</Modal_alta>
<Modal_alta bind:this={pago_modal1}>
        <h2 class="titulo-modal">Payment method</h2>
        <form on:submit|preventDefault={guardar_tarjeta}>
            <div class="container_tarjeta"> 
                <h4>Card number</h4>
                <input type="number" bind:value={tarjeta_number} class="input_modal">
                <h4>Validity</h4>
                <input type="text" class="input_modal_2" bind:value={MM} placeholder="MM">/<input type="text" class="input_modal_2" bind:value={AA} placeholder="AA">
                <h4>CVV</h4>
                <input type="number"  bind:value={cvc} class="input_modal">
                <input type="submit" class="modal_button" value="Pay">
            </div>
        </form>
</Modal_alta>
<Modal_alta bind:this={modal_agregar_tarjeta}>
    <h2 class="titulo-modal">New Card</h2>
    <form on:submit|preventDefault={agregar_tarjeta_nueva}>
        <div class="container_tarjeta"> 
            <h4>Card number</h4>
            <input type="number" bind:value={tarjeta_number} class="input_modal">
            <h4>Validityo</h4>
            <input type="text" class="input_modal_2" bind:value={MM} placeholder="MM">/<input type="text" class="input_modal_2" bind:value={AA} placeholder="AA">
            <h4>CVV</h4>
            <input type="number"  bind:value={cvc} class="input_modal">
            <input type="submit" class="modal_button" value="Add card">
        </div>
    </form>
</Modal_alta>
<Modal_series  bind:this={modal_tecnicos}>
    <h2 class="titulo-modal">List of technicians</h2>
    <div class="tabla_tecnicos">
        <table>
            <thead>
                <th class="column">Name</th>
                <th class="column1">Alta</th>
                <th class="column2">Email</th>
                <th class="column3">Cell phone</th>
                <th class="column4">Skype</th>
                <th class="column5"></th>
                <th class="column5"></th>
                <th class="column6"></th>
            </thead>
            <tbody>
                {#each data as row, i}
                <tr>
                    <td class="column">{row.nombre}</td>
                    <td class="column1">{row.alta}</td>
                    <td class="column2">{row.correo}</td>
                    <td class="column3">{row.celular}</td>
                    <td class="column4">{row.skype}</td>
                    <td class="column6" on:click={() => eliminar_tecnico_licencia(i)}><img src="./img/menos.svg" alt=""></td>
                </tr>
                {/each}
            </tbody>
        </table>
    </div>
</Modal_series>
